import React, { useEffect, useState } from 'react';
import './message.css';
import GetLangConfig from '../../util/LangUtil';

interface ErrorInt {
    message: any;
    handleError: Function;
}

export default function MessageComponent(props: ErrorInt) {
    const [hideMessage, updateHideMessage] = useState(true);
    const langConfig = GetLangConfig('message');
    const [errorMessages, setErrorMessages] = useState<string[]>([]);

    useEffect(() => {
        if (props.message === undefined) {
            updateHideMessage(true);
            return;
        }

        updateHideMessage(false);
        const timer = setTimeout(() => {
            closeMessage();
        }, 10000);

        // Parse error messages
        const parseErrorMessage = (message: any): string[] => {
            // Handle Error instances
            try {
                const errors = message.response?.data?.errors;
                if (typeof errors === 'string') {
                    const parsedErrors = JSON.parse(errors);
                    if (Array.isArray(parsedErrors)) {
                        return parsedErrors;
                    }
                }
                if (Array.isArray(errors)) {
                    return errors;
                }
            } catch {
                // ignore and fallback
            }


            // Handle AJAX error responses
            if (message.ajax) {
                const responseText = message.ajax.response?.request?.responseText ||
                    message.ajax.request?.responseText;
                try {
                    const parsed = JSON.parse(responseText);
                    return parsed.errors || [parsed.message || responseText];
                } catch {
                    return Array.isArray(responseText) ? responseText : [responseText];
                }
            }

            // Handle string messages (could be JSON)
            if (typeof message === 'string') {
                try {
                    const parsed = JSON.parse(message);
                    return parsed.errors || [parsed.message || message];
                } catch {
                    return [message];
                }
            }

            // Handle object with errors array or message property
            if (typeof message === 'object') {
                if (Array.isArray(message.errors)) {
                    return message.errors.map(e => e.message || e);
                }
                if (message.message) {
                    return [message.message];
                }
                return [JSON.stringify(message)];
            }

            return ['Unknown error occurred'];
        };

        setErrorMessages(parseErrorMessage(props.message));

        return () => clearTimeout(timer);
    }, [props.message]);

    function closeMessage() {
        props.handleError(undefined);
        updateHideMessage(true);
    }

    const getTranslatedMessage = (error: string) => {
        error = error?.toLowerCase() ?? "";

        if (error.includes('invalid username') || error.includes('invalid password')) {
            return langConfig.message.invalidUsernamePwd;
        } else if (error.includes('password cannot be empty')) {
            return langConfig.message.emptyPassword;
        } else if (error.includes('passwords must be at least')) {
            return langConfig.settings.pwdmsg1;
        } else if (error.includes('one non alphanumeric character')) {
            return langConfig.settings.pwdmsg2;
        } else if (error.includes('at least one digit')) {
            return langConfig.settings.pwdmsg3;
        } else if (error.includes('at least one uppercase')) {
            return langConfig.settings.pwdmsg4;
        } else if (error.includes('the provided policy number does not match any employers')) {
            return langConfig.message.invalidPolicyNum;
        } else if (error.includes('invalid token')) {
            return langConfig.general.invalidtoken;
        }
        return error;
    };

    return (
        <>
            {!hideMessage && props.message && (
                <div className={'message-container'}>
                    {props.message.error === true || props.message instanceof Error ? (
                        <div className="error">
                            <h2>{langConfig.message.header}</h2>
                            <ul>
                                {errorMessages.map((e, index) => (<li key={`${index}-${e?.substring(0, 10)}`}>
                                            {getTranslatedMessage(e)}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                    ) : (
                        <div className="success">
                            <h1>{langConfig.message.requestSubmitted}</h1>
                        </div>
                    )}
                    <div className="close" onClick={closeMessage}>X</div>
                </div>
            )}
        </>
    );
}